import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs/esm/index';
import utc from 'dayjs/esm/plugin/utc';

dayjs.extend(utc);

/**
 * Native-Angular port of the AngularJS `dateFormat` filter
 * (account-v1/.../date-range/dateFormat.filter.js): `moment.utc(date).format(fmt)`
 * with default format 'MMM D' and UTC default true. Coerces numeric-string epochs
 * (the v1 templates piped through `parse:'number'` first — folded in here).
 */
@Pipe({
    name: 'dateFormat',
    standalone: false
})
export class DateFormatPipe implements PipeTransform {
  transform(date: number | string | Date | null | undefined, format = 'MMM D', isUtc = true): string {
    if (date === null || date === undefined || date === '') return '';
    const value = typeof date === 'string' && /^\d+$/.test(date) ? Number(date) : date;
    const d = isUtc ? dayjs.utc(value as string | number | Date) : dayjs(value as string | number | Date);
    return d.isValid() ? d.format(format) : '';
  }
}
